import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "./App.css";
import "../node_modules/react-image-gallery/styles/scss/image-gallery.scss";
import "../node_modules/react-image-gallery/styles/css/image-gallery.css";

import StarName from "./container/StarName";
import RealCode from "./container/RealCode";
import HappyQR from "./container/HappyQR";
import Gallery from "./container/Gallery";
import Preview from "./container/Preview";
import StarNameApp from "./container/StarNameApp";
import Register from "./container/Register";
import Event01 from "./container/Event01";
import { ScreenClassProvider } from "react-grid-system";

function setScreenSize() {
  console.log("set screen size");
  let vh = window.innerHeight * 0.01;
  console.log(vh);
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

class App extends Component {
  componentDidMount() {
    setScreenSize();
  }

  render() {
    return (
      <Router>
        <ScreenClassProvider>
          <Route exact path="/" component={StarName} />
          <Route path="/starname/:starnameId" component={StarName} />
          <Route path="/realcode/:qrkey" component={RealCode} />
          <Route path="/happyqr/:qrkey" component={HappyQR} />
          <Route path="/gallery/:idx" component={Gallery} />
          <Route path="/preview/:starnameId" component={Preview} />
          <Route path="/starnameapp/:uid" component={StarNameApp} />
          <Route path="/register/:oid" component={Register} />
          <Route path="/event01/:oid" component={Event01} />
        </ScreenClassProvider>
      </Router>
    );
  }
}

export default App;
